import { createMemo } from "solid-js"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import isMapControlTarget, { type MapControlTargetEntity } from "../../lib/core/entity/isMapControlTarget"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedEntityGraphNodeListMemo } from "./createSharedEntityGraphNodeListMemo"

// return all MapControlTarget ents
export const useSharedMapControlTargetEntsListMemo = createSharedCachedFactory((engine) => {

  const getEntityGraphNodeList = createSharedEntityGraphNodeListMemo(engine)

  const getMapControlTargetEntsList = createMemo<Array<EntityGraphNode<MapControlTargetEntity>>>(() => {
    const list: Array<EntityGraphNode<MapControlTargetEntity>> = getEntityGraphNodeList().filter(isMapControlTarget) as Array<EntityGraphNode<MapControlTargetEntity>>
    return list
  }, [], {
    equals: isIdListSame,
  })

  // createEffect(() => {
  //   console.log('getMapControlTargetEntsList', getMapControlTargetEntsList())
  // })

  return getMapControlTargetEntsList
})
